import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  type BulkApproveDlnItemsPayload,
  type BulkApproveDlnItemsResponse,
} from './types';
import {
  zodBulkApproveDlnItemsBodySchema,
  zodBulkApproveDlnItemsEndpointSchema,
  zodSuccessResponseSchema,
} from './validations';

/**
 * Bulk-approves delivery note items for a given asset ID.
 *
 * @param assetId - The delivery note asset ID.
 * @param payload - The items to approve with accepted quantity factors.
 * @param options - Optional request options (e.g. abort signal).
 * @returns The API success response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Delivery-Note/operation/bulk_approve_dln_items_delivery_note__asset_id__item_bulk_approve_put
 */
export const bulkApproveDlnItems = async (
  assetId: UUID,
  payload: BulkApproveDlnItemsPayload,
  options?: KyRequestOptions,
) => {
  const response = await vestigasApi
    .put(ENDPOINT.DELIVERY_NOTE.BULK_APPROVE_ITEMS(assetId), {
      json: payload,
      validate: {
        body: zodBulkApproveDlnItemsBodySchema,
        pathSegments: zodBulkApproveDlnItemsEndpointSchema,
      },
      ...options,
    })
    .json<BulkApproveDlnItemsResponse>();

  return zodSuccessResponseSchema.parse(response);
};
